/**
 * Danh sách email được phép truy cập trang Admin.
 * Thêm email vào mảng này để cấp quyền admin.
 *
 * Lưu ý: Sau khi chỉnh sửa, cần build lại dự án để áp dụng.
 */
export const ADMIN_EMAILS: string[] = [
  '123trading.vn@gmail.com',
];

/**
 * Kiểm tra xem email có phải admin không (không phân biệt hoa thường)
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.some(
    (adminEmail) => adminEmail.toLowerCase() === email.toLowerCase()
  );
}